import React from 'react';
import PropTypes from 'prop-types';
import { cx } from 'emotion';
import { audienceTitles } from 'inside-out/managers/resourceLibraryManager';
import { AudienceFilter } from 'inside-out/components/resource-library/audienceFilter';

import {
	componentWrapStyle,
	componentDropDownStyle,
	componentInnerStyle,
	backdropStyle
} from './styles';

import AudienceIcon from 'inside-out/components/shared/icons/audienceIcon';

class AudienceDropDownComponent extends React.PureComponent {
	state = {
		open: false,
	};

	close = () => {
		this.setState({
			open: false
		});
	}

	open = () => {
		this.setState(prevState => ({
			open: !prevState.open,
		}));
	}

	onChange = audience => {
		this.props.onChange(audience);
		this.close();
	}

	render() {
		const { open } = this.state;
		const { value, className } = this.props;
		return (
			<div className={cx(componentWrapStyle, className)}>
				<button onClick={this.open} className={componentInnerStyle(open)}>
          <AudienceIcon audience={{ id: value }} size={12} />
          <span>{audienceTitles[value] || 'All Resources'}</span>
        </button>
        {open && (
        	<React.Fragment>
	        	<div className={backdropStyle} onClick={this.close}/>
						<div className={componentDropDownStyle}>
							<AudienceFilter activeAudience={value} onChange={this.onChange} />
						</div>
					</React.Fragment>
      	)}
			</div>
		);
	}
}

AudienceDropDownComponent.propTypes = {
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	className: PropTypes.string,
};

export const AudienceDropDown = AudienceDropDownComponent;



// WEBPACK FOOTER //
// ./src/components/resource-library/audienceDropDown/component.js